import { useEffect, useState } from "react";

const useGetConfig = (params) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    setIsLoading(true);
    setError(null);

    fetch(`/api/getConfig?id=${params}`, { signal })
      .then((response) => {
        if (!response.ok) {
          // throw new Error("Failed to fetch data");
        }
        return response.json();
      })
      .then((json) => {
        setData(json);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          setError(err.message);
        }
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [params]);

  return { data, isLoading, error };
};

export default useGetConfig;
